export class NewsletterSubsForm {
    public email!: string
    public listName!: string
}
